<kodit-table [tableConfig]="tableConfig" [paginatedData]="paginatedData!" [chipItems]="chipItems">
</kodit-table>
